export default __webpack_public_path__ + "static/Consulting-e809e5fb3d391bbe3cb99dffcb563df3.png";